var crypto = window.crypto || window.msCrypto;

module.exports = function(compare){
  //from http://stackoverflow.com/a/2117523/505832
  return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = crypto.getRandomValues(new Uint8Array(1))[0]%16|0, v = c == 'x' ? r : (r&0x3|0x8);
    return v.toString(16);
  });
}
